var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Viagem",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "uf_carregamento",
      "label-for": "uf_carregamento",
      "label": "UF de carregamento"
    }
  }, [_c('VueSelect', {
    ref: "uf_carregamento",
    class: {
      hasErrors: _vm.ufError
    },
    attrs: {
      "filterable": false,
      "options": _vm.ufsSearched1
    },
    on: {
      "search": function search(_search, loading) {
        return _vm.searchUf(_search, 1);
      },
      "input": function input() {
        return _vm.ufError = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.sigla) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.sigla) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.uf_carregamento,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "uf_carregamento", $$v);
      },
      expression: "form.uf_carregamento"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe a UF ")])], 2)], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "cidade_carregamento",
      "label-for": "cidade_carregamento",
      "label": "Cidade de Carregamento"
    }
  }, [_c('VueSelect', {
    ref: "cidade_carregamento",
    class: {
      hasErrors: _vm.cidadeError
    },
    attrs: {
      "filterable": false,
      "options": _vm.cidades
    },
    on: {
      "search": _vm.onSearchCidades,
      "input": function input() {
        return _vm.cidadeError = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.cidade) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.cidade) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.cidade_carregamento,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cidade_carregamento", $$v);
      },
      expression: "form.cidade_carregamento"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome da cidade ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "uf_descarga",
      "label-for": "uf_descarga",
      "label": "UF de descarga"
    }
  }, [_c('VueSelect', {
    ref: "uf_descarga",
    class: {
      hasErrors: _vm.ufErrorDescarga
    },
    attrs: {
      "filterable": false,
      "options": _vm.ufsSearched2
    },
    on: {
      "search": function search(_search2, loading) {
        return _vm.searchUf(_search2, 2);
      },
      "input": function input() {
        return _vm.ufErrorDescarga = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.sigla) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.sigla) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.uf_descarga,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "uf_descarga", $$v);
      },
      expression: "form.uf_descarga"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe a UF ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "cep_carregamento",
      "label-for": "cep_carregamento",
      "label": "CEP de carregamento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "8",
      "autofocus": "",
      "state": _vm.validateState('cep_carregamento')
    },
    model: {
      value: _vm.form.cep_carregamento,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cep_carregamento", $$v);
      },
      expression: "form.cep_carregamento"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "cep_descarga",
      "label-for": "cep_descarga",
      "label": "CEP de descarga"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "8",
      "autofocus": "",
      "state": _vm.validateState('cep_descarga')
    },
    model: {
      value: _vm.form.cep_descarga,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cep_descarga", $$v);
      },
      expression: "form.cep_descarga"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "percurso",
      "label-for": "percurso",
      "label": "Percurso"
    }
  }, [_c('VueSelect', {
    ref: "percurso",
    class: {
      hasErrors: _vm.ufErrorDescarga
    },
    attrs: {
      "multiple": "",
      "filterable": false,
      "options": _vm.ufsSearched3
    },
    on: {
      "search": function search(_search3, loading) {
        return _vm.searchUf(_search3, 3);
      },
      "input": function input(value) {
        _vm.handleSelectPercurso(value);
        _vm.ufErrorDescarga = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.sigla) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.sigla) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.percurso,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "percurso", $$v);
      },
      expression: "form.percurso"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe a UF ")])], 2)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };